import { AnalysisResultChip, AnalysisResultVariant, Stack, Typography } from 'ui';

import { GuideImage } from '../GuideImage/GuideImage';

export const EvidenceFeedback = ({
  src,
  caption,
  variant,
}: {
  src: string;
  caption: string;
  variant: AnalysisResultVariant;
}) => {
  return (
    <Stack
      sx={{
        position: 'relative',
      }}
    >
      <GuideImage src={src} alt={caption} />
      {variant ? <AnalysisResultChip variant={variant} /> : null}
      <Typography
        color={variant === 'yes' ? 'success' : 'error'}
        sx={{
          textAlign: 'start',
        }}
      >
        {caption}
      </Typography>
    </Stack>
  );
};
